module.exports = __webpack_public_path__ + "media/zuopin4.bdcdc9cb.mp4";